//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductsCard from '~/components/ProductsCard'
import ShareButtons from '~/components/ShareButtons'

export default {
  auth: false,
  components: {
    ProductsCard,
    ShareButtons
  },
  async asyncData ({ store }) {
    if (!store.state.collections.length) {
      await store.dispatch('GET_WebsiteData')
    }
  },
  computed: {
    collection () {
      const collections = this.$store.state.collections || []
      const current = this.$route.params.collection
      return collections.find((item) => {
        const idMatch = item && item.id != null && String(item.id) === String(current)
        const slugMatch = this.slugify(item && item.name) === String(current)
        return idMatch || slugMatch
      }) || null
    },
    products () {
      if (!this.collection || !Array.isArray(this.collection.products)) {
        return []
      }
      return this.collection.products
    },
    collectionShareUrl () {
      const baseUrl = process.client
        ? window.location.origin
        : (this.$config.WEB_URL || '')
      return `${baseUrl}${this.$route.path}`
    },
    collectionShareText () {
      const collectionName = this.collection && this.collection.name
        ? this.collection.name
        : 'esta colección'
      return `Mira ${collectionName} en ${this.$config.STORE_NAME}`
    }
  },
  methods: {
    slugify (value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
    },
    acquireCollection () {
      if (!this.products.length) { return }

      this.products.forEach((product) => {
        this.$store.dispatch('cart/updateCart', {
          item: Object.assign({}, product),
          qty: 1,
          isAdd: true
        })
      })

      this.$store.commit('SHOW_Cart', true)
      this.$notify.show({
        text: `Se agregaron ${this.products.length} productos al carrito`,
        type: 'success',
        closeWait: 2500
      })
    }
  },
  head () {
    const title = this.collection && this.collection.name ? this.collection.name : 'Colección'
    const description = this.collection && this.collection.description
      ? this.collection.description
      : 'Detalle de colección y productos'
    return {
      title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: description }
      ]
    }
  }
}
